"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionsDiffChecker = void 0;

var _react = _interopRequireWildcard(require("react"));

var _NavTab = _interopRequireDefault(require("@cimpress/react-components/lib/NavTab"));

var _NavTabItem = _interopRequireDefault(require("@cimpress/react-components/lib/NavTabItem"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = require("@cimpress/react-components/lib/colors");

var _OptionCard = require("./OptionCard");

var _find = _interopRequireDefault(require("lodash/find"));

var _helper = require("./helper");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var OptionsDiffChecker = function OptionsDiffChecker(_ref) {
  var v1 = _ref.v1,
      v2 = _ref.v2;
  var addedOption = {
    border: "1.5px solid ".concat(_colors.info.darkest),
    color: "".concat(_colors.info.darkest)
  };
  var removedOption = {
    color: "".concat(_colors.info.darkest, " "),
    textDecoration: "line-through"
  };
  var navTabStyle = {
    flex: 1
  };
  var navBodyStyle = {
    flex: 3,
    paddingLeft: '10px'
  };
  var optionCardTypeText = {
    fontSize: '13px'
  };
  var navBarNotificationStyle = {
    width: '7px',
    height: '7px',
    background: "".concat(_colors.info.darkest, " "),
    borderRadius: '50%',
    marginTop: '5px',
    marginLeft: '5px'
  };
  var unchangedType = 'unchanged';
  var addedType = 'added';
  var removedType = 'removed';
  var v1Clone = (0, _cloneDeep["default"])(v1);

  var existsInV1 = function existsInV1(name) {
    var spliceIt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return v1Clone.some(function (option, index) {
      if (option.name === name) {
        spliceIt && v1Clone.splice(index, 1);
        return true;
      }

      return false;
    });
  };

  var _useState = (0, _react.useState)(v2[0]),
      _useState2 = _slicedToArray(_useState, 2),
      selectedTab = _useState2[0],
      setSelectedTab = _useState2[1];

  var _useState3 = (0, _react.useState)(existsInV1(v2[0].name, false) ? unchangedType : addedType),
      _useState4 = _slicedToArray(_useState3, 2),
      optionType = _useState4[0],
      setOptionType = _useState4[1];

  var hasDiff = function hasDiff(option) {
    var v1Option = (0, _find["default"])(v1, {
      name: option.name
    });
    return (0, _helper.hasDiffValues)(option.values, v1Option.values);
  };

  var generateOptionBody = function generateOptionBody(selectedOption, type) {
    if (type === removedType) {
      return (
        /*#__PURE__*/
        _react["default"].createElement("div", null,
        /*#__PURE__*/
        _react["default"].createElement("h5", {
          style: optionCardTypeText
        }, "Removed Option"),
        /*#__PURE__*/
        _react["default"].createElement(_OptionCard.OptionCard, {
          option: selectedOption,
          key: selectedOption.name,
          cardCss: removedOption
        }))
      );
    }

    if (type === addedType) {
      return (
        /*#__PURE__*/
        _react["default"].createElement("div", null,
        /*#__PURE__*/
        _react["default"].createElement("h5", {
          style: optionCardTypeText
        }, "Added New"),
        /*#__PURE__*/
        _react["default"].createElement(_OptionCard.OptionCard, {
          option: selectedOption,
          key: selectedOption.name,
          cardCss: addedOption
        }))
      );
    }

    return (
      /*#__PURE__*/
      _react["default"].createElement(_OptionCard.OptionCard, {
        option: selectedOption,
        key: selectedOption.name,
        v1: (0, _find["default"])(v1, {
          name: selectedOption.name
        })
      })
    );
  };

  var setData = function setData(option, type) {
    setSelectedTab(option);
    setOptionType(type);
  };

  var navBarNotification =
  /*#__PURE__*/
  _react["default"].createElement("div", {
    style: navBarNotificationStyle
  });

  return (
    /*#__PURE__*/
    _react["default"].createElement(_react.Fragment, null,
    /*#__PURE__*/
    _react["default"].createElement("div", {
      style: {
        display: 'flex'
      }
    },
    /*#__PURE__*/
    _react["default"].createElement(_NavTab["default"], {
      vertical: true,
      style: navTabStyle
    }, v2.map(function (option) {
      return existsInV1(option.name) ?
      /*#__PURE__*/
      _react["default"].createElement(_NavTabItem["default"], {
        key: option.name,
        active: selectedTab === option
      },
      /*#__PURE__*/
      _react["default"].createElement("button", {
        onClick: function onClick() {
          return setData(option, unchangedType);
        },
        style: {
          display: 'flex'
        }
      }, option.name, hasDiff(option) ?
      /*#__PURE__*/
      _react["default"].createElement("sup", null, navBarNotification) : null)) :
      /*#__PURE__*/
      _react["default"].createElement(_NavTabItem["default"], {
        key: option.name,
        active: selectedTab === option
      },
      /*#__PURE__*/
      _react["default"].createElement("button", {
        onClick: function onClick() {
          return setData(option, addedType);
        },
        style: {
          display: 'flex'
        }
      }, option.name,
      /*#__PURE__*/
      _react["default"].createElement("sup", null, navBarNotification)));
    }), v1Clone.map(function (option) {
      return (
        /*#__PURE__*/
        _react["default"].createElement(_NavTabItem["default"], {
          key: option.name,
          active: selectedTab === option
        },
        /*#__PURE__*/
        _react["default"].createElement("button", {
          onClick: function onClick() {
            return setData(option, removedType);
          },
          style: {
            display: 'flex'
          }
        }, option.name,
        /*#__PURE__*/
        _react["default"].createElement("sup", null, navBarNotification)))
      );
    })),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      style: navBodyStyle
    }, generateOptionBody(selectedTab, optionType))))
  );
};

exports.OptionsDiffChecker = OptionsDiffChecker;
OptionsDiffChecker.propTypes = {
  optionsNew: _propTypes["default"].array,
  optionsOld: _propTypes["default"].array
};